import { modals } from '@mantine/modals';
import type { TranslateFn } from '@newo/localization';
import ChatFlowFinalModal from '../components/ChatFlowFinalModal';

export const CREATOR_CHAT_FLOW_FINALIZATION_MODAL_ID =
	'creator-chat-flow-finalization';

export const openCreatorChatFlowFinalizationModal = (
	translate: TranslateFn
) => {
	modals.open({
		centered: true,
		closeOnClickOutside: false,
		closeOnEscape: false,
		modalId: CREATOR_CHAT_FLOW_FINALIZATION_MODAL_ID,
		padding: 28,
		radius: 24,
		size: 'auto',
		title: null,
		withCloseButton: false,
		children: (
			<ChatFlowFinalModal
				modalId={CREATOR_CHAT_FLOW_FINALIZATION_MODAL_ID}
				translate={translate}
			/>
		)
	});
};
